var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PopUpOverlay',{attrs:{"width":"600px"},on:{"closeOverlay":function($event){_vm.setDialogNewProjectShow(false), _vm.new_project_name = ''}},scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('TText',{attrs:{"value":"create_new_project","font_weight":"400","medium":""}})]},proxy:true},{key:"body",fn:function(){return [_c('DisableableInputField',{attrs:{"label":"Projectname","is_disabled":false,"value":_vm.new_project_name,"background_color":"color-1"},on:{"change":function($event){_vm.new_project_name = $event}}}),_c('div',{staticClass:"d-flex align-center pt-2"},[_c('RadialCheckbox',{attrs:{"foreground_color":"white","shadow":"black","is_checked":_vm.is_checked},nativeOn:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.is_checked = !_vm.is_checked}}}),_c('TText',{staticClass:"pl-2",attrs:{"value":"Add_to_Company","font_weight":"400","medium":""}})],1)]},proxy:true},{key:"additional_v-btn_right",fn:function(){return [_c('v-btn',{attrs:{"color":"green lighten-1","text":"text"},on:{"click":function($event){_vm.createUObject({
            url: [
              {projects: ''},
              {'showWithEntitiesNormalized': ''}
            ],
            u_object: {
              name: _vm.new_project_name,
              add_to_business: _vm.is_checked
            }
          }).then((id) => {
            _vm.joinProject(id);
            _vm.enterEditMode({project_id: id});
            _vm.$router.push({
              name: 'AddTrain',
              params: {
                project_id: id,
                train_index: 0,
                direction: 0
              }
            });
            _vm.setDialogNewProjectShow(false), _vm.new_project_name = ''
          })}}},[_c('TText',{attrs:{"value":"Create_Project","color":"green","font_weight":"400"}})],1),_c('v-btn',{attrs:{"color":"green lighten-1","text":"text"},on:{"click":function($event){_vm.createUObject({
            url: [
              {multiprojects: ''},
              {'showWithEntitiesNormalized': ''}
            ],
            u_object: {
              name: _vm.new_project_name
            }
          }).then((id) => {
            _vm.setDialogNewProjectShow(false), _vm.new_project_name = ''
          })}}},[_c('TText',{attrs:{"value":"Create_Multiproject","color":"green","font_weight":"400"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }